import { put, call, all, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/transactionHistory'
import {
  getCustomerAccounts,
  getTransactionHistorySummary as getTransactionSummary,
  getTransactionHistoryReport as getTransactionReport
} from 'services'
import { ACTION_TYPES as NOTIFICATION_TYPES } from 'store/reducers/notification'
import { REQUEST_ERROR, TRANSACTION_HISTORY } from 'config/messages'

const {
  TRANSACTION_HISTORY_REQUEST,
  TRANSACTION_HISTORY_SUCCESS,
  TRANSACTION_HISTORY_ERROR,
  TRANSACTION_HISTORY_SUMMARY_REQUEST,
  TRANSACTION_HISTORY_SUMMARY_SUCCESS,
  TRANSACTION_HISTORY_SUMMARY_ERROR,
  TRANSACTION_HISTORY_REPORT_REQUEST,
  TRANSACTION_HISTORY_REPORT_SUCCESS,
  TRANSACTION_HISTORY_REPORT_ERROR
} = ACTION_TYPES

export function *getTransactionHistory() {
  try {
    const response = yield call(getCustomerAccounts)
    yield put({ type: TRANSACTION_HISTORY_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: TRANSACTION_HISTORY_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export function *getTransactionHistorySummary(payload) {
  try {
    const response = yield call(getTransactionSummary, payload)
    if (response.status === 200) {
      yield put({ type: TRANSACTION_HISTORY_SUMMARY_SUCCESS, payload: response })
    } else if (response.status === 204) {
      yield put({ type: TRANSACTION_HISTORY_SUMMARY_ERROR, payload: response })
      yield put({
        type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
        payload: { text: TRANSACTION_HISTORY.NO_RESULT_ERROR, type: 'error' }
      })
    }
  } catch (err) {
    yield put({ type: TRANSACTION_HISTORY_SUMMARY_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export function *getTransactionHistoryReport(payload) {
  try {
    let format
    let fileName

    switch (payload.payload.format) {
      case 'pdf':
        format = 'application/pdf'
        fileName = `ResumoNegociacao_${payload.payload.endDate}.pdf`
        break
      default:
        format = 'text/x-csv'
        fileName = `ResumoNegociacao_${payload.payload.endDate}.csv`
    }

    const response = yield call(getTransactionReport, payload)
    yield put({ type: TRANSACTION_HISTORY_REPORT_SUCCESS, payload: { response, format, fileName } })
  } catch (err) {
    yield put({ type: TRANSACTION_HISTORY_REPORT_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export default function *watchTransactionHistory() {
  yield all([
    takeLatest(TRANSACTION_HISTORY_REQUEST, getTransactionHistory),
    takeLatest(TRANSACTION_HISTORY_SUMMARY_REQUEST, getTransactionHistorySummary),
    takeLatest(TRANSACTION_HISTORY_REPORT_REQUEST, getTransactionHistoryReport)
  ])
}
